
import { uniqueToken, GpsBaseURL } from "../api/DataApis";
import request from "./request";


export const getInvoice = async (invoicePayload) => {
    console.log("invoicePayload", invoicePayload);
   
    const InvoicegenerateApi = `${GpsBaseURL}/web/order/invoice-generate`;
  
      let res = await request({
        url: InvoicegenerateApi,
        method: "Post",
        data: invoicePayload,
      
        headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
  
      if (res && res?.data) {
        //const data = res.data.student;
        // console.log("res",res.students)
        return res?.data
      }
      return [];
  }